import {
    createSlice,
} from '@reduxjs/toolkit';

import {
    refreshBetslip,
} from '~Betslip/thunks/refreshBetslip';

import {
    clearSelections,
    removeSelection,
    clearPricesByCombinationType,
} from '~Betslip/actions/userSelectionsActions';

import {
    updateSelectionBatch,
} from '~Betslip/actions/selectionDetailsActions';

import {
    placeBet,
} from '~Betslip/thunks/placeBet';

import {
    suspendSelectionsInStore,
} from '~Betslip/utils/selectionFormatters';

import {
    getInitialCombinationSelectionDetails,
    isCombinationSelection,
} from '~Betslip/utils/combinationsUtils';

const initialState = {};

const selectionDetails = createSlice({
    name: 'betslip/selectionDetails',
    initialState,
    reducers: {
        updateSelection: (state, action) => {
            const {
                id,
                ...rest
            } = action.payload;

            const selection = state[id];
            if (!selection) {
                return;
            }

            Object.assign(selection, rest);
        },
    },
    extraReducers: (builder) =>{
        builder
        .addCase(
            updateSelectionBatch,
            (state, action) => {
            const selections = action.payload;
                Object.keys(selections).map((id) => {
                    if (state[id] && selections[id]) {
                        return Object.assign(state[id], selections[id]);
                    }

                    return null;
                });
            },
        )
        .addCase(
            refreshBetslip.fulfilled,
            (_state, { payload: { selection_details, combinations: combinationsArray = [] } }) => {
                const combinations = combinationsArray.reduce(
                    (combinationsObject, combination) => {
                        const combinationDetails = getInitialCombinationSelectionDetails(combination);
                        const { id } = combinationDetails;
                        combinationsObject[id] = combinationDetails;

                        return combinationsObject;
                    },
                    {},
                );

                return { ...selection_details, ...combinations};
            },
        )
        .addCase(clearSelections, () => (initialState))
        .addCase(
            placeBet.fulfilled,
            (state, { payload }) => {
                suspendSelectionsInStore(payload, state);
            },
        )
        .addCase(
            removeSelection,
            (state, { payload: selectionIdToRemove }) => Object.keys(state).reduce(
                (updated, currentSelectionId) => {
                    const selection = state[currentSelectionId];
                    /**
                     * We know what selectionIds the new combination selection will have, so we compute it and mark as
                     * stale. Prevents unnessary combinations renders/content jumps while we wait for the
                     * fetchBetslipData request to resolve with up to date data on new combination. We assume all
                     * underlying selections have numeric id's
                     * Mark other selections stale. When BE responds, we can register for updates with new combinations.
                     */
                    if (isCombinationSelection(selection)) {
                        if (selection.selections.includes(Number(selectionIdToRemove))) {
                            const underlyingSelections = selection.selections;
                            // if only one selection remains there will be no combination in response
                            if (underlyingSelections.length > 2) {
                                const updatedSelections = underlyingSelections.filter(
                                    uSelectionId => uSelectionId !== Number(selectionIdToRemove)
                                );
                                const dummyCombination = {
                                    ...getInitialCombinationSelectionDetails(selection),
                                    stale: true,
                                    selections: updatedSelections,
                                };

                                return { ...updated, [dummyCombination.id]: dummyCombination };
                            }

                            return updated;
                        }

                        // other combinations
                        return { ...updated, [selection.id]: { ...selection, stale: true } };

                    } else if (currentSelectionId !== selectionIdToRemove) {

                        return { ...updated, [currentSelectionId]: selection };
                    }

                    return updated;
                },
                {},
            ),
        )
        .addCase(
            clearPricesByCombinationType,
            (state, { payload: typeToClear }) => {
                Object.keys(state).forEach(
                    selectionId => {
                        const selection = state[selectionId];
                        if (selection.combination_type === typeToClear) {
                            selection.decimal_price = null;
                            selection.fraction_price = null;
                        }
                    }
                );
            }
        );
    },
});

export const {
    updateSelection,
} = selectionDetails.actions;

export default selectionDetails.reducer;
